export default __webpack_public_path__ + "static/orangelinetrain1-021e27ee4524efe85d4aa7c19ed4a674.jpg";